'use client';

import { Button } from '@coolblue-development/freddy';
import pickUpInStoreTrigger from '@coolblue-development/ga4-events/triggers/OrderBlock/pickUpInStoreTrigger';
import orderBlockSummaryPickUpInStoreTrigger from '@coolblue-development/ga4-events/triggers/OrderBlockSummary/pickUpInStoreTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import type { Product } from '@features/product/typings';
import { useTranslation } from '@i18n/useTranslation';
import { useState } from 'react';

import StoreStockModal from '../StoreStockModal/StoreStockModal';

type StorePickupButtonProps = {
  product: Product;
  dateOverride?: string;
  isOrderSummary?: boolean;
};

export function StorePickupButton({
  product,
  dateOverride,
  isOrderSummary
}: StorePickupButtonProps) {
  const { trackEvent } = useAnalytics();
  const [open, setOpen] = useState(false);
  const { t } = useTranslation('webshop.productPage');

  const handleLinkClick = () => {
    setOpen(true);
    trackEvent(
      isOrderSummary
        ? orderBlockSummaryPickUpInStoreTrigger({
            sub_feature: 'pick_up_button'
          })
        : pickUpInStoreTrigger()
    );
  };

  return (
    <>
      <Button type='button' onClick={handleLinkClick} variant='secondary' fullWidth>
        {t('storePickup.button')}
      </Button>
      <StoreStockModal
        open={open}
        onClose={() => setOpen(false)}
        product={product}
        dateOverride={dateOverride}
      />
    </>
  );
}
